import React from 'react';
import { useReportButtonState } from '@/hooks/useReportButtonState';
import { UserData } from '@/types/user';
import ActionButton from '../ActionButton';

interface ReportButtonProps {
  userData: UserData | null;
}

export default function ReportButton({ userData }: ReportButtonProps) {
  const buttonState = useReportButtonState(userData);

  const getButtonProps = () => {
    switch (buttonState) {
      case 'active':
        return {
          title: "View Your Report",
          description: "Your comprehensive feedback report is ready",
          disabled: false,
          reportAvailable: true,
          isCompleted: false, // Don't show completed state
          onboardingRequired: userData ? !userData.onboardingCompleted : false
        };
      case 'pending':
        return {
          title: "View Your Report",
          description: "Your report will be available 24 to 48 hours after all tasks are completed.",
          disabled: false,
          reportAvailable: false,
          isCompleted: false,
          onboardingRequired: userData ? !userData.onboardingCompleted : false
        };
      case 'disabled':
        return {
          title: "View Your Report",
          description: "Your report will be available 24 to 48 hours after all tasks are completed.",
          disabled: true,
          reportAvailable: false,
          isCompleted: false,
          onboardingRequired: userData ? !userData.onboardingCompleted : false
        };
    }
  };

  return (
    <ActionButton
      {...getButtonProps()}
      route="/report"
      isReport={true}
    />
  );
}